// extracted by mini-css-extract-plugin
export default {"popup":"coordinatesPopup_popup__W-t9I"};